<script setup>
import { computed } from 'vue';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const modelValue = computed({
  get: () => props.isSelected,
  set: () => emit('toggle', props.id),
});
</script>

<template>
  <CardLayout selectable class="relative [&>div]:!py-4" layout="row">
    <div class="absolute top-[1.125rem] ltr:left-3 rtl:right-3">
      <Checkbox v-model="modelValue" />
    </div>

    <div class="flex flex-col w-full">
      <span class="text-sm text-n-slate-12 font-medium">{{ title }}</span>
      <span v-if="description" class="text-sm text-n-slate-11 mt-2">
        {{ description }}
      </span>
    </div>
  </CardLayout>
</template>
